import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import TargetCreate from './TargetCreate';
import TargetEdit from './TargetEdit';
import TargetList from './TargetList';
import TargetShow from './TargetShow';

const pages = {
    list: TargetList,
    create: TargetCreate,
    edit: TargetEdit,
    show: TargetShow,
    icon: TrackChangesIcon,
};

export default pages;